module.exports = __webpack_public_path__ + "static/img/img_gy_e_b.0ad3ef1d.png";